import * as privateOrderChatActions from '@actions/private-order-chat';

const initialState = {
    orderId: null,
    chatId: null,

    search: '',
    currentPage: undefined,
    lastPage: 1,
    total: null,

    chatFellow: null,
    readMessages: [],
    unreadMessages: [],

    getPrivateOrderChatRequest: {
        isProcessing: false,
        error: null,
    },

    sendMessageRequest: {
        isProcessing: false,
        error: null,
    },
};

const privateOrderChat = (state = initialState, action) => {
    switch (action.type) {
        case privateOrderChatActions.SET_PRIVATE_ORDER_CHAT_DATA: {
            const { orderId, chatId, read_messages: readMessages, unread_messages: unreadMessages, chat_fellow: chatFellow } = action.payload;
            const { current_page: currentPage, last_page: lastPage, total } = readMessages;

            return {
                ...state,
                orderId,
                chatId,
                chatFellow,
                currentPage,
                lastPage,
                total: Number(state.total) + total,
                readMessages: [...readMessages.data.filter(({ id }) => !state.readMessages.find(message => message.id === id)), ...state.readMessages],
                unreadMessages,
            };
        }
        case privateOrderChatActions.SET_IS_GET_PRIVATE_ORDER_CHAT_REQUEST_PROCESSING: {
            return {
                ...state,
                getPrivateChatRequest: {
                    ...state.getPrivateChatRequest,
                    isProcessing: action.payload,
                },
            };
        }
        case privateOrderChatActions.SET_GET_PRIVATE_ORDER_CHAT_REQUEST_ERROR: {
            return {
                ...state,
                getPrivateChatRequest: {
                    ...state.getPrivateChatRequest,
                    error: action.payload,
                },
            };
        }
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_READ_MESSAGES: {
            const readMessages = state.unreadMessages.filter(({ id }) => action.payload.includes(id));
            const unreadMessages = state.unreadMessages.filter(({ id }) => !action.payload.includes(id));

            return {
                ...state,
                readMessages: [...state.readMessages, ...readMessages],
                unreadMessages,
            };
        }
        case privateOrderChatActions.SET_IS_SEND_MESSAGE_PRIVATE_ORDER_CHAT_REQUEST_PROCESSING: {
            return {
                ...state,
                sendMessageRequest: {
                    ...state.sendMessageRequest,
                    isProcessing: action.payload,
                },
            };
        }
        case privateOrderChatActions.SET_SEND_MESSAGE_PRIVATE_ORDER_CHAT_REQUEST_ERROR: {
            return {
                ...state,
                sendMessageRequest: {
                    ...state.sendMessageRequest,
                    error: action.payload,
                },
            };
        }
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_SEND_MESSAGE: {
            return {
                ...state,
                readMessages: [...state.readMessages, ...state.unreadMessages, action.payload],
                unreadMessages: [],
            };
        }
        case privateOrderChatActions.ADD_NEW_PRIVATE_ORDER_CHAT_UNREAD_MESSAGE: {
            if (!state.readMessages.find(({ id }) => id === action.payload.id) && !state.unreadMessages.find(({ id }) => id === action.payload.id)) {
                return {
                    ...state,
                    unreadMessages: [...state.unreadMessages, action.payload],
                };
            }

            return state;
        }
        // Кейс когда из другой вкладки приходит наше сообщение в вебсокетах
        case privateOrderChatActions.ADD_NEW_PRIVATE_ORDER_CHAT_READ_MESSAGE: {
            if (!state.readMessages.find(({ id }) => id === action.payload.id) && !state.unreadMessages.find(({ id }) => id === action.payload.id)) {
                return {
                    ...state,
                    readMessages: [...state.readMessages, action.payload],
                };
            }

            return state;
        }
        // Нужно в любом случае пометить сообщения прочитанными и перенести прочитанные из непрочитанных, если такие есть
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_SET_MESSAGES_READ: {
            return {
                ...state,
                readMessages: [
                    // Помечаем нами прочитанные сообщения - прочитанными
                    ...state.readMessages.map(message => ({
                        ...message,
                        is_another_user_read: message.is_another_user_read || action.payload.includes(message.id),
                    })),
                    // Добавляем прочитанные сообщения из непрочитанных
                    ...state.unreadMessages
                        .filter(({ id }) => action.payload.includes(id))
                        .map(message => ({
                            ...message,
                            is_another_user_read: message.is_another_user_read || action.payload.includes(message.id),
                        })),
                ],
                // Убираем прочитанные сообщения из непрочитанных
                unreadMessages: state.unreadMessages.filter(({ id }) => !action.payload.includes(id)),
            };
        }
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_SET_SEARCH: {
            return {
                ...initialState,
                orderId: state.orderId,
                chatId: state.chatId,
                search: action.payload,
            };
        }
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_SET_RESET: {
            return { ...initialState };
        }
        case privateOrderChatActions.PRIVATE_ORDER_CHAT_UPDATE_MESSAGE: {
            return {
                ...state,
                total: state.total + action.payload,
            };
        }
        default:
            return state;
    }
};

export default privateOrderChat;
